import { AuthModel, UserModel } from '../modules/auth'
import { api } from './config/api'
import { API_URL, USER_API_URL } from './config/constants'
import { Usuario } from './models'

export const GET_USER_BY_ACCESSTOKEN_URL = `${USER_API_URL}/ValidateToken`
export const LOGIN_URL = `${USER_API_URL}/Login`
export const LOGOFF_URL = `${USER_API_URL}/Logoff`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export async function login(s_usuario : string, s_senha: string): Promise<{auth: AuthModel, user: UserModel}> {
  const {data} = await api.post<Usuario>(LOGIN_URL, {
    s_usuario,
    s_senha,
    // esta versão possui a tela de renovação por Pix: licença vencida entra e é levada para /renovacao
    b_suporta_renovacao: true,
  })
  

  const {s_token_acesso, ...userData} = data

  return {
    auth: {
      api_token: s_token_acesso as string,
      refreshToken: s_token_acesso,
      company_id: userData.id_empresa,
      user_id: userData.id,
      empresa: {
        id: userData.id_empresa,
        ...(userData.empresa ?? {}),
      }
    },
    user: {
      username: userData.s_usuario,
      // password: userData.password,
      companyName: userData.s_empresa,
      phone: userData.s_telefone,
      fullname: userData.s_nome,
      first_name: userData.s_nome?.split(' ')?.[0],
      last_name: userData.s_nome?.split(' ')?.[1],
      email: userData.s_email,
      occupation: userData.s_tipo,
      company_id: userData.id_empresa,
      ...userData
    }
  }
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return api.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return api.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function logoutUser(api_token: string, s_usuario:string) {
  return api.post(LOGOFF_URL, {
    api_token,
    s_usuario
  })
}

export function getUserByToken(token: string) {
  return api.post<Usuario>(GET_USER_BY_ACCESSTOKEN_URL, {
    s_token_acesso: token,
  })
}
